/* ============================= */
/* VERSION V1.2 - FOOTER FINAL */
/* Tracking GA4 : téléphone / email / WhatsApp / réseaux sociaux */
/* Commune de rattachement : Buc */
/* ============================= */

import React, { useEffect, useState } from "react";
import "../styles/Footer.css";
import logo from "../assets/logo/logo-taxi-de-la-douce.svg";
import { trackEvent } from "../utils/analytics";

const Footer = () => {
  const year = new Date().getFullYear();

  // Compteur simple avec localStorage
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    try {
      const key = "taxideladouce_visits";
      const current = Number(localStorage.getItem(key) || 0) + 1;

      localStorage.setItem(key, String(current));
      setVisits(current);
    } catch {
      setVisits(null);
    }
  }, []);

  return (
    <footer className="footer-premium" role="contentinfo">
      <div className="footer-container">

        {/* ============================= */}
        {/* CONTENU PRINCIPAL */}
        {/* ============================= */}

        <div className="footer-grid">

          {/* ============================= */}
          {/* COLONNE MARQUE */}
          {/* ============================= */}

          <div className="footer-col">
            <img
              src={logo}
              alt="Logo Taxi de la Douce"
              className="footer-logo"
              width="70"
              height="70"
              loading="lazy"
              decoding="async"
            />

            <h5 className="footer-title">
              Taxi de la Douce
            </h5>

            <p className="footer-subtitle">
              Taxi • Transferts gare de Belfort • Aéroport Bâle-Mulhouse •
              Longue distance
            </p>
          </div>

          {/* ============================= */}
          {/* CONTACT */}
          {/* ============================= */}

          <div className="footer-col">
            <h6 className="footer-heading">
              Contact
            </h6>

            {/* Téléphone */}
            <p className="footer-line">
              <span aria-hidden="true">📞</span>{" "}
              <a
                href="tel:+33749424919"
                className="footer-link"
                onClick={() =>
                  trackEvent("click_call", {
                    event_category: "contact",
                    event_label: "footer_call",
                    value: 1,
                  })
                }
              >
                +33 7 49 42 49 19
              </a>
            </p>

            {/* Email */}
            <p className="footer-line">
              <span aria-hidden="true">📧</span>{" "}
              <a
                href="mailto:urtaxi90@gmail.com"
                className="footer-link"
                onClick={() =>
                  trackEvent("click_email", {
                    event_category: "contact",
                    event_label: "footer_email",
                    value: 1,
                  })
                }
              >
                urtaxi90@gmail.com
              </a>
            </p>

            {/* WhatsApp */}
            <p className="footer-line">
              <span aria-hidden="true">💬</span>{" "}
              <a
                href="https://wa.me/33749424919"
                className="footer-link"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackEvent("click_whatsapp", {
                    event_category: "contact",
                    event_label: "footer_whatsapp",
                    value: 1,
                  })
                }
              >
                WhatsApp
              </a>
            </p>

            {/* Commune de rattachement */}
            <p className="footer-line">
              <span aria-hidden="true">📍</span>{" "}
              Commune de rattachement :{" "}
              <strong className="footer-location">
                Buc (90800)
              </strong>
            </p>
          </div>
        </div>

        {/* ============================= */}
        {/* RÉSEAUX SOCIAUX */}
        {/* ============================= */}

        <div className="footer-social">

          {/* Facebook */}
          <a
            href="https://www.facebook.com/letransportdeladouce/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook Taxi de la Douce"
            onClick={() =>
              trackEvent("click_social", {
                event_category: "social",
                event_label: "footer_facebook",
                value: 1,
              })
            }
          >
            <i className="bi bi-facebook"></i>
          </a>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/chauffeurvtc90/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram Taxi de la Douce"
            onClick={() =>
              trackEvent("click_social", {
                event_category: "social",
                event_label: "footer_instagram",
                value: 1,
              })
            }
          >
            <i className="bi bi-instagram"></i>
          </a>

          {/* Snapchat */}
          <a
            href="https://snapchat.com/add/taxideladouce"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Snapchat Taxi de la Douce"
            onClick={() =>
              trackEvent("click_social", {
                event_category: "social",
                event_label: "footer_snapchat",
                value: 1,
              })
            }
          >
            <i className="bi bi-snapchat"></i>
          </a>
        </div>

        {/* ============================= */}
        {/* BAS DE PAGE */}
        {/* ============================= */}

        <div className="footer-bottom">

          <p>
            © {year} Taxi de la Douce — Tous droits réservés.
          </p>

          <p className="footer-dev">
            Site développé par Taxi de la Douce • Version 1.2
          </p>

          {visits !== null && (
            <p className="footer-visits">
              Visites du site : {visits}
            </p>
          )}
        </div>

      </div>
    </footer>
  );
};

export default Footer;